import { Fragment } from 'react';
import style from './ProductsMenu.scss';

const ProductsMenu = () => {
  return (
    <Fragment>
      <div
        className={`lil-my-3 md:lil-hidden lg:lil-hidden xl:lil-hidden ${style['mainMobileWrapper']}`}
      >
        <div className="lil-mb-4">
          <details className="lil-w-full lil-accordian">
            <summary className="lil-cursor-pointer">
              <div className="lil-flex lil-items-center lil-rounded-xl">
                <img
                  className="lil-w-1/12"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1602841792_section4_enterprise.png"
                  alt="enterprise"
                  width="35"
                  height="35"
                />
                <div
                  className="lil-w-10/12
                                lil-font-bold
                                lil-text-font-600
                                lil-text-s-20
                                lil-ml-4"
                >
                  Enterprise
                </div>
                <div className="lil-w-1/12 lil-accordian-caret lil-order-3 lil-ml-auto"></div>
              </div>
            </summary>
            <div className="lil-block lil-bg-grey-150 lil-py-4 lil-rounded-lg lil-mt-4">
              <a target="_blank" href="https://cleartax.in/gst">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">Full-stack ASP/GSP solution</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                href="https://cleartax.in/s/e-invoicing-enterprise-software"
              >
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606372771_einvoicing3.png"
                      alt="ClearE-Invoicing"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearE-Invoicing
                    </p>
                    <p className="lil-text-s-14">
                      Fast, dependable, affordable
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                href="https://cleartax.in/s/gst-eway-bill-software"
              >
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967983_ic_ewayb.svg"
                      alt="ClearE-Waybill"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearE-Waybill
                    </p>
                    <p className="lil-text-s-14">Simple, accurate and smart</p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/tds">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606218204_cleartds.svg"
                      alt="ClearTDS"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearTDS
                    </p>
                    <p className="lil-text-s-14">Manage e-TDS payment</p>
                  </div>
                </div>
              </a>
            </div>
          </details>
        </div>
        <div className="lil-mb-4">
          <details className="lil-w-full lil-accordian">
            <summary className="lil-cursor-pointer">
              <div className="lil-flex lil-items-center lil-rounded-xl">
                <img
                  className="lil-w-1/12"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1602841570_section4_tax_expert.png"
                  alt="tax_expert"
                  width="35"
                  height="35"
                />
                <div
                  className="
                                lil-w-10/12
                                lil-font-bold
                                lil-text-font-600
                                lil-text-s-20
                                lil-ml-4
                                "
                >
                  Tax Experts
                </div>
                <div
                  className="
                                lil-w-1/12 lil-accordian-caret lil-order-3 lil-ml-auto
                                "
                ></div>
              </div>
            </summary>
            <div
              className="
										lil-block lil-bg-grey-150 lil-py-4 lil-rounded-lg lil-mt-4
									"
            >
              <a target="_blank" href="https://cleartax.in/gst">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">
                      G1-G9 filings made 3x faster
                    </p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/tds">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606218204_cleartds.svg"
                      alt="ClearTDS"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearTDS
                    </p>
                    <p className="lil-text-s-14">
                      e-TDS return filing solution
                    </p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://taxcloudindia.com/">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603968183_ic_taxcloud.svg"
                      alt="ClearTaxCloud"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearTaxCloud
                    </p>
                    <p className="lil-text-s-14">Manage ITRs for people</p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/s/clearpro">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1614344289_clearproapp.svg"
                      alt="ClearPro App"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearPro App
                    </p>
                    <p className="lil-text-s-14">Track filing status</p>
                  </div>
                </div>
              </a>
            </div>
          </details>
        </div>
        <div className="lil-mb-4">
          <details className="lil-w-full lil-accordian">
            <summary className="lil-cursor-pointer">
              <div className="lil-flex lil-items-center lil-rounded-xl">
                <img
                  className="lil-w-1/12"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1602841679_section4_sme.png"
                  alt="sme"
                  width="35"
                  height="35"
                />
                <div
                  className="
                                lil-w-10/12
                                lil-font-bold
                                lil-text-font-600
                                lil-text-s-20
                                lil-ml-4
                                "
                >
                  SMEs
                </div>
                <div
                  className="
                                lil-w-1/12 lil-accordian-caret lil-order-3 lil-ml-auto
                                "
                ></div>
              </div>
            </summary>
            <div
              className="
										lil-block lil-bg-grey-150 lil-py-4 lil-rounded-lg lil-mt-4
									"
            >
              <a target="_blank" href="https://cleartax.in/clearone/">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1618557796_clearone.svg"
                      alt="ClearOne"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearOne
                    </p>
                    <p className="lil-text-s-14">
                      Easy invoicing for businesses
                    </p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/gst">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">Filing, invoicing, matching</p>
                  </div>
                </div>
              </a>
            </div>
          </details>
        </div>
        <div className="lil-mb-4">
          <details className="lil-w-full lil-accordian">
            <summary className="lil-cursor-pointer">
              <div className="lil-flex lil-items-center lil-rounded-xl">
                <img
                  className="lil-w-1/12"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1602841460_section4_individuals.png"
                  alt="individuals"
                  width="35"
                  height="35"
                />
                <div
                  className="
                                lil-w-10/12
                                lil-font-bold
                                lil-text-font-600
                                lil-text-s-20
                                lil-ml-4
                                "
                >
                  Individuals
                </div>
                <div
                  className="
                                lil-w-1/12 lil-accordian-caret lil-order-3 lil-ml-auto
                                "
                ></div>
              </div>
            </summary>
            <div
              className="
										lil-block lil-bg-grey-150 lil-py-4 lil-rounded-lg lil-mt-4
									"
            >
              <a
                target="_blank"
                href="https://www.cleartax.in/income-tax-efiling"
              >
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603968068_ic_itr.svg"
                      alt="File ITR"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      File ITR
                    </p>
                    <p className="lil-text-s-14">Tax returns in under 7 min</p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/save">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606217655_clearinvest.svg"
                      alt="ClearInvest"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearInvest
                    </p>
                    <p className="lil-text-s-14">Save and grow wealth</p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/services/">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606217684_clearservices.svg"
                      alt="ClearServices"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      ClearServices
                    </p>
                    <p className="lil-text-s-14">
                      Get experts for filing taxes
                    </p>
                  </div>
                </div>
              </a>

              <a target="_blank" href="https://cleartax.in/s/black">
                <div
                  className="
												lil-flex lil-items-center lil-p-2 lil-dropdown-menu-item
											"
                >
                  <div className="lil-w-2/12">
                    <img
                      loading="lazy"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967633_ic_black_app.svg"
                      alt="Black"
                      width="35"
                      height="35"
                    />
                  </div>
                  <div className="lil-w-10/12">
                    <p className="lil-text-base lil-font-bold lil-text-font-600">
                      Black
                    </p>
                    <p className="lil-text-s-14">More money in your pocket</p>
                  </div>
                </div>
              </a>
            </div>
          </details>
        </div>
      </div>
      <div
        className={`sm:lil-hidden lil-flex lil-fixed lil-rounded-xl lil-shadow-lg ${style['dropdownclass']}`}
      >
        <div className="lil-w-full">
          <div
            className={`lil-flex lil-w-full lil-container lil-border-b-sm lil-border-grey-300 nav-menu-container ${style['innerwrapper']}`}
          >
            <a
              href="https://cleartax.in/enterprise"
              className="lil-w-1/4 lil-mb-4 lil-dropdown-submenu"
            >
              <div className="lil-flex lil-py-2 lil-px-1 lil-items-center lil-dropdown-submenu-header  lil-rounded-xl">
                <div className="lil-w-1/5">
                  <img
                    loading="lazy"
                    src="https://assets1.cleartax-cdn.com/cleartax/images/1605874053_enterprise.svg"
                    alt="enterprise"
                    width="44"
                    height="44"
                  />
                </div>
                <div className="lil-w-4/5">
                  <h6>Enterprise</h6>
                </div>
              </div>
            </a>
            <a
              href="https://cleartax.in/tax-experts"
              className="lil-w-1/4 lil-mb-4 lil-dropdown-submenu"
            >
              <div className="lil-flex lil-py-2 lil-px-1 lil-items-center lil-dropdown-submenu-header  lil-rounded-xl">
                <div className="lil-w-1/5">
                  <img
                    loading="lazy"
                    src="https://assets1.cleartax-cdn.com/cleartax/images/1605873968_taxexpert.svg"
                    alt="taxexpert"
                    width="44"
                    height="44"
                  />
                </div>
                <div className="lil-w-4/5">
                  <h6>Tax Experts</h6>
                </div>
              </div>
            </a>
            <a
              href="https://cleartax.in/sme"
              className="lil-w-1/4 lil-mb-4 lil-dropdown-submenu"
            >
              <div className="lil-flex lil-py-2 lil-px-1 lil-items-center lil-dropdown-submenu-header  lil-rounded-xl">
                <div className="lil-w-1/5">
                  <img
                    loading="lazy"
                    src="https://assets1.cleartax-cdn.com/cleartax/images/1605874025_sme.svg"
                    alt="sme"
                    width="44"
                    height="44"
                  />
                </div>
                <div className="lil-w-4/5">
                  <h6>SMEs</h6>
                </div>
              </div>
            </a>
            <a
              href="https://cleartax.in/you"
              className="lil-w-1/4 lil-mb-4 lil-dropdown-submenu"
            >
              <div className="lil-flex lil-py-2 lil-px-1 lil-items-center lil-dropdown-submenu-header  lil-rounded-xl">
                <div className="lil-w-1/5">
                  <img
                    loading="lazy"
                    src="https://assets1.cleartax-cdn.com/cleartax/images/1605873928_individuals.svg"
                    alt="individuals"
                    width="44"
                  />
                </div>
                <div className="lil-w-4/5">
                  <h6>Individuals</h6>
                </div>
              </div>
            </a>
          </div>
          <div
            className={`lil-flex lil-w-full lil-container lil-mt-8 ${style['innerwrapper']}`}
          >
            <div className="lil-w-1/4 lil-dropdown-submenu">
              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/gst"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">Full-stack ASP/GSP solution</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/s/e-invoicing-enterprise-software"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606372771_einvoicing3.png"
                      alt="ClearE-Invoicing"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearE-Invoicing
                    </p>
                    <p className="lil-text-s-14">
                      Fast, dependable, affordable
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/s/gst-eway-bill-software"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967983_ic_ewayb.svg"
                      alt="ClearE-Waybill"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearE-Waybill
                    </p>
                    <p className="lil-text-s-14">Simple, accurate and smart</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/tds"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606218204_cleartds.svg"
                      alt="ClearTDS"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearTDS
                    </p>
                    <p className="lil-text-s-14">Manage e-TDS payment</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="lil-w-1/4 lil-dropdown-submenu">
              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/gst"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">
                      G1-G9 filings made 3x faster
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/tds"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606218204_cleartds.svg"
                      alt="ClearTDS"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearTDS
                    </p>
                    <p className="lil-text-s-14">
                      e-TDS return filing solution
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://taxcloudindia.com/"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603968183_ic_taxcloud.svg"
                      alt="ClearTaxCloud"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearTaxCloud
                    </p>
                    <p className="lil-text-s-14">Manage ITRs for people</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/s/clearpro"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1614344289_clearproapp.svg"
                      alt="ClearPro App"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearPro App
                    </p>
                    <p className="lil-text-s-14">Track filing status</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="lil-w-1/4 lil-dropdown-submenu">
              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/clearone/"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1618557796_clearone.svg"
                      alt="ClearOne"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearOne
                    </p>
                    <p className="lil-text-s-14">
                      Easy invoicing for businesses
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/gst"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg"
                      alt="ClearGST"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearGST
                    </p>
                    <p className="lil-text-s-14">Filing, invoicing, matching</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="lil-w-1/4 lil-dropdown-submenu">
              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://www.cleartax.in/income-tax-efiling"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603968068_ic_itr.svg"
                      alt="File ITR"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      File ITR
                    </p>
                    <p className="lil-text-s-14">Tax returns in under 7 min</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/save"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606217655_clearinvest.svg"
                      alt="ClearInvest"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearInvest
                    </p>
                    <p className="lil-text-s-14">Save and grow wealth</p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/services/"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1606217684_clearservices.svg"
                      alt="ClearServices"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      ClearServices
                    </p>
                    <p className="lil-text-s-14">
                      Get experts for filing taxes
                    </p>
                  </div>
                </div>
              </a>

              <a
                target="_blank"
                className={`lil-py-6 ${style['links']}`}
                href="https://cleartax.in/s/black"
              >
                <div
                  className={`lil-flex lil-items-center lil-p-3 ${style['dropdownitems']}`}
                >
                  <div className="lil-w-1/5">
                    <img
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1603967633_ic_black_app.svg"
                      alt="Black"
                      width="45"
                      height="45"
                    />
                  </div>
                  <div className="lil-w-4/5">
                    <p
                      className="
                        lil-text-base lil-text-font-500 lil-font-semibold
                      "
                    >
                      Black
                    </p>
                    <p className="lil-text-s-14">More money in your pocket</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductsMenu;



// WEBPACK FOOTER //
// ./pages/currency/components/Navbar/Productmenu/ProductsMenu.tsx